module.exports = __webpack_public_path__ + "img/3-2.a986f5cf.png";